import React, { useState, useEffect } from "react";
import { Table, Input, Col, Row, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";

import PageHeading from "../../../components/common/PageHeading";
import RightBar from "../../../components/common/RightBar";
import { useAuthState } from "react-firebase-hooks/auth";

import { VendorsRightBar, tableData, tradeList } from "./vendersData";

import { getDocs, collection, doc, where, query } from "firebase/firestore";
import { auth, db } from "../../../firebase";
import "./venders.css";
import { NavLink, useNavigate } from "react-router-dom";

function Vendors() {
  const [sortedInfo, setSortedInfo] = useState({});
  const [companyName, setCompanyName] = useState("");
  const [user, loading] = useAuthState(auth);
  const [isLoading, setIsLoading] = useState(false);

  const [searchState, setSearchState] = useState({
    query: "",
    list: [],
  });
  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));

      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setCompanyName(res.companyName);
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };

  const [allVendorData, setAllVendorData] = useState([]);
  console.log("allVendorDataallVendorData",allVendorData)
  const getVendors = async () => {
    setIsLoading(true);
    try {
      const companiesRef = collection(db, "companies");
      const companyDocRef = doc(companiesRef, companyName);
      const vendorRef = collection(companyDocRef, "vendors");
      const data = await getDocs(vendorRef);
      const vendorsData = data.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      setSearchState((prevState) => ({
        ...prevState,
        list: vendorsData,
      }));
   
      console.log(vendorsData.id);
      setAllVendorData(vendorsData);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false); // stop loading
    }
  };
  useEffect(() => {
    if (companyName) {
      getVendors();
    }

    fetchCompanyName();
    console.log("**************88");
  }, [companyName]);

  console.log(searchState);
  const navigate = useNavigate();

  const handleSearchByName = (e) => {
    const results = allVendorData.filter((post) => {
      if (e.target.value === "") return post;
      return post.vendorInfo.firstName
        .toLowerCase()
        .includes(e.target.value.toLowerCase());
    });
    setSearchState({
      query: e.target.value,
      list: results,
    });
  };
  const handleSearchByAddress = (e) => {
    const results = allVendorData.filter((post) => {
        if (e.target.value === "") return post;

        // Check if addresses array exists and has at least one address with an addressOne property
        const hasValidAddress = post.contact 
            && post.contact.addresses 
            && post.contact.addresses.length > 0 
            && post.contact.addresses[0].addressOne;

        return hasValidAddress 
            ? post.contact.addresses[0].addressOne
                .toLowerCase()
                .includes(e.target.value.toLowerCase())
            : false;
    });

    setSearchState({
        query: e.target.value,
        list: results,
    });
};

  const handleSearchByTrade = (value) => {
    const results = allVendorData.filter((post) => {
      if (value === "" || value === undefined) return post;
      return post.vendorInfo.venderTrade
        .toLowerCase()
        .includes(value.toLowerCase());
    });
    setSearchState({
      query: value,
      list: results,
    });
  };
  const handleSearchByEmail = (e) => {
    const results = allVendorData.filter((post) => {
      if (e.target.value === "") return post;

      // Check if addresses array exists and has at least one address with an addressOne property
      const hasValidAddress = post.contact 
          && post.contact.emails 
          && post.contact.emails.length > 0 
          && post.contact.emails[0].email;

      return hasValidAddress 
          ? post.contact.emails[0].email
              .toLowerCase()
              .includes(e.target.value.toLowerCase())
          : false;
  });

  setSearchState({
      query: e.target.value,
      list: results,
  });
  };

  const handleChange = (pagination, filters, sorter, extra) => {
    console.log("params", pagination, filters, sorter, extra);
    setSortedInfo(sorter);
  };

  const tableHeader = [
    {
      title: "Name",
      dataIndex: "firstName",
      key: "firstName",
      sorter: (a, b) =>
        a.vendorInfo.firstName.length - b.vendorInfo.firstName.length,
      sortOrder: sortedInfo.columnKey === "firstName" ? sortedInfo.order : null,
      ellipsis: true,
      render: (_, document) => (
        <span className="onclick-text">
          <NavLink to={document.id}> {document.vendorInfo.firstName}</NavLink>
        </span>
      ),
    },
    {
      title: "Address",
      dataIndex: "vendorAddress1-0",
      key: "address",
      render: (_, document) => (
        <span className="onclick-text">
          {document.contact.addresses.length > 0
            ? document.contact.addresses[0].zipCode
            : "--"}
          ,
          {document.contact.addresses.length > 0
            ? document.contact.addresses[0].addressOne
            : "--"}
          ,
          {document.contact.addresses.length > 0
            ? document.contact.addresses[0].addressTwo
            : "--"}
          {document.contact.addresses.length > 0
            ? document.contact.addresses[0].city
            : "--"}
          {document.contact.addresses.length > 0
            ? document.contact.addresses[0].state
            : "--"}
        </span>
      ),
      // sorter: (a, b) =>
      //   a.vendorAddress["vendorAddress1-0"].addressOne.length -
      //   b.vendorAddress["vendorAddress1-0"].addressOne.length,
      // sortOrder: sortedInfo.columnKey === "address" ? sortedInfo.order : null,
    },
    {
      title: "Trades",
      dataIndex: "venderTrade",
      key: "trades",
      render: (_, document) => (
        <span className="onclick-text">{document.vendorInfo.venderTrade},</span>
      ),
      // sorter: (a, b) =>
      //   a.vendorInfo.venderTrade.length - b.vendorInfo.venderTrade.length,
      // sortOrder: sortedInfo.columnKey === "trades" ? sortedInfo.order : null,
    },
    {
      title: "Phone",
      dataIndex: "phoneNumber0",
      key: "phone",
      render: (_, document) => (
        <span className="onclick-text">
          {document.contact.phoneNumbers?.length > 0
            ? document.contact.phoneNumbers[0]?.phoneNumber
            : "--"}
          ,
        </span>
      ),
      // sorter: (a, b) =>
      //   a.vendorContacts.phoneNumber0.phoneNumber.length -
      //   b.vendorContacts.phoneNumber0.phoneNumber.length,
      // sortOrder: sortedInfo.columnKey === "phone" ? sortedInfo.order : null,
    },
    {
      title: "Email",
      dataIndex: "email0",
      key: "email",
      render: (_, document) => (
        <span className="onclick-text">
          {document.contact.emails?.length > 0
            ? document.contact.emails[0]?.email
            : "--"}
          ,
        </span>
      ),
      // sorter: (a, b) => a.vendorEmail[0].length - b.vendorEmail[0].length,
      // sortOrder: sortedInfo.columnKey === "email" ? sortedInfo.order : null,
    },
  ];

  return (
    <>
      <div>
        <PageHeading heading="Vendors" />
        <Row justify="space-between">
          <Col span={5}>
            <label htmlFor="searchByVender" className="labelForVendorInputs">
              Vendor
            </label>
            <Input
              allowClear
              placeholder="Search by vendor name"
              suffix={
                <SearchOutlined
                  style={{
                    color: "rgba(0,0,0,.45)",
                  }}
                />
              }
              onChange={handleSearchByName}
              name="searchByVender"
            />
          </Col>

          <Col span={5}>
            <label htmlFor="searchByAddress" className="labelForVendorInputs">
              Address or Zip Code
            </label>

            <Input
              placeholder="Search by address or zip code"
              allowClear
              suffix={
                <SearchOutlined
                  style={{
                    color: "rgba(0,0,0,.45)",
                  }}
                />
              }
              onChange={handleSearchByAddress}
              name="searchByAddress"
            />
          </Col>

          <Col span={5} className="searchByTradeFilter">
            <label htmlFor="searchByTrade" className="labelForVendorInputs">
              Trade
            </label>
            <Select
              showSearch
              allowClear={handleSearchByTrade}
              placeholder="Filter by Trade"
              onChange={handleSearchByTrade}
              onSearch={handleSearchByTrade}
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              options={tradeList}
              name="searchByTrade"
            />
          </Col>

          <Col span={5}>
            <label htmlFor="searchByEmail" className="labelForVendorInputs">
              Email
            </label>

            <Input
              placeholder="Search by email"
              allowClear
              suffix={
                <SearchOutlined
                  style={{
                    color: "rgba(0,0,0,.45)",
                  }}
                />
              }
              onChange={handleSearchByEmail}
              name="searchByEmail"
            />
          </Col>
        </Row>

        <br />
        <Table
          columns={tableHeader}
          dataSource={searchState.list}
          onChange={handleChange}
          loading={isLoading}
          rowKey="id"
          onRow={(record) => {
            return {
              onClick: () =>
                navigate(`/people/vendors/vendor-details/${record.id}`),
            };
          }}
        />
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={VendorsRightBar} />
      </div>
    </>
  );
}

export default Vendors;
